import {
  Container,
  Email,
  Logo,
  LogoWrapper,
  Column,
  MenuItem,
  AddressTitle,
  CopyrightRow,
  FooterRow,
  ContactWrapper,
  FooterLogoWrapper,
  EmailIcon,
} from "./Footer.styles";

import { Link } from "react-scroll";

export default function Footer(){
  return (
    <>
      <Container>
        <FooterRow>
          <FooterLogoWrapper>
            <LogoWrapper>
              <Logo src="images/logo-white.svg" />
            </LogoWrapper>
            <CopyrightRow>
              Copyright © 2022 Infovist - Todos os direitos reservados
            </CopyrightRow>
          </FooterLogoWrapper>
          <Column>
            <AddressTitle>Empresa</AddressTitle>
            <MenuItem>
              <Link
                duration={300}
                to="operation"
                smooth
              >
                Como funciona?
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                duration={300}
                to="benefits"
                smooth
              >
                Benefícios
              </Link>
            </MenuItem>
            <MenuItem>Quais dados você recebe</MenuItem>
          </Column>
          <ContactWrapper>
            <AddressTitle>Fale conosco</AddressTitle>
            <Email>
              <EmailIcon src="images/email-icon.png" />
              contato@infovist.com.br
            </Email>
          </ContactWrapper>
        </FooterRow>
      </Container>
    </>
  );
};
